import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { CommercialUserProps } from "../../state/actionType";
import ActionButton from "./ActionButton";

export const TableColumns: ColumnDef<CommercialUserProps>[] = [
  // {
  //   id: "slNo",
  //   header: "Sl. No",
  //   cell: ({ row }) => row.index + 1,
  // },
  {
    accessorFn: (row) => row.user_profile?.name,
    id: "name",
    header: "Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.email,
    id: "email",
    header: "Email",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.mobile_no,
    id: "mobile_no",
    header: "Mobile No.",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.status,
    id: "status",
    header: "Status",
    cell: (info) => info.getValue(),
  },
  {
    id: "action",
    header: "Actions",
    cell: ({ row }) => (
      <div className="flex justify-center items-center gap-2">
        <ActionButton items={row.original} />
      </div>
    ),
    enableSorting: false,
  },
];
